import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Button, Icon, Inline, Message } from "@intility/bifrost-react";
import { useNavigate } from "react-router";
import { useClients } from "../../api/clients";
import { PageLayout } from "../../components/layout/PageLayout";
import { ClientsTable } from "../../components/tables/ClientsTable";

export default function Clients() {
  const { isLoading, error } = useClients();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="bf-content bfl-page-padding">
        <Inline align="center" gap={12}>
          <Icon.Spinner size={24} />
          <span className="bf-p">Loading clients…</span>
        </Inline>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bf-content bfl-page-padding">
        <Message state="warning" header="Failed to load clients">
          {error instanceof Error
            ? error.message
            : "An unexpected error occurred."}
        </Message>
      </div>
    );
  }

  return (
    <PageLayout
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "Clients" }]}
      title="Clients"
      description="Every registered client: SPAs, APIs, workers, MCP servers and AI agents."
      actions={
        <Button variant="filled" onClick={() => navigate("/clients/new")}>
          <Icon icon={faPlus} marginRight />
          New client
        </Button>
      }
    >
      <ClientsTable />
    </PageLayout>
  );
}
